module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vback1-f8462f62c6dfd950bad9c9ccd2db7c37.jpg";